.root {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.dropzone {
  border: 2px dashed var(--line);
  border-radius: var(--r-md);
  padding: 28px 20px;
  background: var(--surface-2);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  cursor: pointer;
  transition: border-color .15s, background .15s;
  text-align: center;
  min-height: 140px;
  outline: none;
}

.dropzone:hover,
.dropzone:focus-visible {
  border-color: var(--role-accent);
  background: var(--surface);
}

.dropzoneActive {
  border-color: var(--role-accent);
  background: var(--role-accent-tint);
}

.dropzoneIcon {
  color: var(--mute);
  margin-bottom: 4px;
}

.dropzoneActive .dropzoneIcon {
  color: var(--role-accent-deep);
}

.dropzoneTitle {
  font-family: var(--sans);
  font-weight: 700;
  font-size: 14px;
  color: var(--ink);
}

.dropzoneHint {
  font-family: var(--sans);
  font-size: 12px;
  color: var(--mute);
}

.preview {
  display: flex;
  gap: 16px;
  align-items: center;
  background: var(--surface);
  border: 1px solid var(--line);
  border-radius: var(--r-md);
  padding: 16px;
}

.previewImgWrap {
  width: 88px;
  height: 88px;
  border-radius: var(--r-sm);
  background: var(--surface-2);
  border: 1px solid var(--line);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  flex-shrink: 0;
}

.previewImg {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.previewActions {
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
}

.btnSecondary,
.btnDanger {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 14px;
  border-radius: var(--r-sm);
  font-family: var(--sans);
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  border: 1px solid var(--line);
  background: var(--surface);
  color: var(--ink);
}

.btnSecondary:hover:not(:disabled) {
  background: var(--surface-2);
}

.btnDanger {
  border-color: var(--line);
  background: var(--surface);
  color: var(--red);
}

.btnDanger:hover:not(:disabled) {
  background: #fbe5e5;
  border-color: #f4b8b8;
}

.btnSecondary:disabled,
.btnDanger:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.spin {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

.error {
  font-family: var(--sans);
  font-size: 12.5px;
  color: var(--red);
  background: #fbe5e5;
  padding: 8px 12px;
  border-radius: var(--r-sm);
  border: 1px solid #f4b8b8;
}

.hiddenInput {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}
